import { createRoute } from '@tanstack/react-router'
import { rootRoute } from 'src/router/root-route'

import AuthLayout from '../AuthLayout'

export const authLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => <AuthLayout />,
  id: 'auth-layout'
})
